import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  AiListeningBrandProfileApiService,
  DateRangeParams,
} from 'src/services/aiListeningApi/brandProfile'

// checkedAt picks a Reload History run; omitted = the latest run in the
// from/to window (none = Lifetime).
export const useGetAiListeningPromptDeepDiveQuery = (
  promptId?: string,
  checkedAt?: string,
  { from, to }: DateRangeParams = {}
) => {
  return useQuery({
    enabled: !!promptId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      AiListeningBrandProfileApiService.getDeepDive(promptId ?? '', checkedAt, {
        from,
        to,
      }),
    queryKey: [
      QueryKey.GET_AI_LISTENING_PROMPT_DEEP_DIVE,
      promptId,
      checkedAt,
      from,
      to,
    ],
  })
}
